import React from 'react';
import type { ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		display: 'flex',
		minHeight: '92px',
		paddingBlock: token('space.200'),
		paddingInline: token('space.200'),
		justifyContent: 'center',
		alignItems: 'center',
		alignSelf: 'stretch',
		borderRadius: token('radius.large'),
		boxSizing: 'border-box',
	},
	message: {
		font: token('font.body'),
		fontFeatureSettings: "'liga' off, 'calt' off",
		color: token('color.text.disabled'),
		textAlign: 'center',
	},
});

export type SectionEmptyStateProps = {
	/** Why the section is empty, and what would fill it. */
	message: ReactNode;
	testId?: string;
};

/**
 * What a whole connection section shows in place of its card when it has nothing to list.
 * The section keeps its header; this replaces the container underneath, so an empty
 * section still reads as present rather than missing, and every section explains its
 * emptiness in the same box.
 */
export const SectionEmptyState = ({
	message,
	testId,
}: SectionEmptyStateProps): React.JSX.Element => (
	<Box xcss={styles.container} testId={testId}>
		<Box as="span" xcss={styles.message}>
			{message}
		</Box>
	</Box>
);
